import { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import { zProductsPriceResponseDto as zSchemaDto } from '@/gen/bff/zod.gen'
import { getBffPrices } from '@/helpers/getBffPrices'
import { defaultDataConverter } from '@/lib/converters/defaultDataConverter'
import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { getPricesConverter } from '@/lib/converters/prices/getPrices/getPricesConverter'

import type { Currency } from '@/config/tenants/types'
import type { getPrices } from '@/gen/bff'

export interface ProductPriceResult {
  productId?: string
  priceData: ReturnType<typeof getBffPrices>
  quantity?: number
}

/**
 * Transforms a raw getPrices response into the price rows the UI consumes. Shared by the batched
 * price query and the per-product (targeted) price queries so both produce an identical shape.
 */
export const createProductPricesSelect =
  (baseSiteId: string, currency: Currency, locale: string) =>
  (res: Awaited<ReturnType<typeof getPrices>>): ProductPriceResult[] => {
    const responseDto = zSchemaDto.catch(defaultZodCatch).parse(defaultDataConverter(res))
    const response = getPricesConverter(responseDto)

    return response.productPrices.map((product) => ({
      productId: product?.productId,
      priceData: getBffPrices(
        product.price,
        baseSiteId.includes('b2c') ? SiteContextModeEnum.b2c : SiteContextModeEnum.b2b,
        currency,
        locale
      ),
      quantity: product?.quantity,
    }))
  }
